import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { expVal } from '@confluence/feature-experiments';

import useSpaceDetailQuery from './__generated__/useSpaceDetailQuery.graphql';
import type { useSpaceDetailQuery$data } from './__generated__/useSpaceDetailQuery.graphql';

const getEmptyResult = () => Promise.resolve({ data: null, loading: false, error: null });

export const fetchSpaceDetail = async (
	spaceKey: string | null | undefined = '',
): Promise<{
	data: useSpaceDetailQuery$data | null;
	loading?: boolean;
	error?: ApolloErrorInterop | null;
}> => {
	if (spaceKey) {
		return query({
			query: useSpaceDetailQuery,
			variables: {
				spaceKey,
			},
		});
	}

	return getEmptyResult();
};

export const preloadSpaceDetail = async (spaceKey: string | null | undefined = '') => {
	if (!expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		return fetchSpaceDetail(spaceKey);
	}

	return getEmptyResult();
};
